import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'
import { changeTotalRecords } from './slice'

export const getReports = createAsyncThunk(
  'dashboard/latestReports/getReports',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await DashboardService.getReports(params)
      if (res.success) {
        dispatch(changeTotalRecords(res.totalRecords))
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
